import React from "react";
import { useTranslation } from "react-i18next";
import Hero from "src/components/Hero/Hero";
import TitleSection from "src/components/TitleSection/TitleSection";
import ReactMarkdown from "react-markdown";
import EventFinished from "src/components/EventFinished";
import TBCBPageWrapper from "src/components/Promotions/TBCB/TBCBPageWrapper";
import TBCBDrawDatesSection from "src/components/Promotions/TBCB/TBCBDrawDatesSection";
import TBCBPrizeTablesSection from "src/components/Promotions/TBCB/TBCBPrizeTablesSection";
import TBCBHowItWorksSection from "src/components/Promotions/TBCB/TBCBHowItWorksSection";
import { ListText } from "src/components/Promotions/TBCB/TBCBStyledComponents";

const TripleBarrelCashBlastFebruary2026 = () => {
  const { t } = useTranslation();
  const heroImage = t("tripleBarrelCashBlastFebruary2026.hero.image");

  return (
    <TBCBPageWrapper>
      <EventFinished
        scheduleKeyName="tripleBarrelCashBlastFebruary2026"
        eventType="promotion"
      />
      <Hero
        image={heroImage}
        bgImage={t("tripleBarrelCashBlastFebruary2026.hero.bgImage")}
        imageAlt={t("tripleBarrelCashBlastFebruary2026.hero.imageAlt")}
        fluidImage={heroImage ? false : true}
      />
      <container-div>
        <TitleSection
          as={"h2"}
          title={t("tripleBarrelCashBlastFebruary2026.content.title")}
          text={t("tripleBarrelCashBlastFebruary2026.content.subtitle")}
          borderColor="#d59947"
          className="mt-4 pb-2"
        />
        <ListText>
          <ReactMarkdown>
            {t("tripleBarrelCashBlastFebruary2026.content.text")}
          </ReactMarkdown>
        </ListText>
        <TBCBDrawDatesSection translationKeyPrefix="tripleBarrelCashBlastFebruary2026" />
        <TBCBPrizeTablesSection
          translationKeyPrefix="tripleBarrelCashBlastFebruary2026"
          imagePath="2026"
        />
      </container-div>
      <TBCBHowItWorksSection translationKeyPrefix="tripleBarrelCashBlastFebruary2026" />
    </TBCBPageWrapper>
  );
};

export default TripleBarrelCashBlastFebruary2026;
